import { tw } from '@/utils/tw';

const VideoPlaylist = tw.theme({
  base: [
    'aller-video-container',
    'h-[calc((100vw-16px)*1.777/2.25+37px)]',
    '[@media(min-width:736px)]:h-[calc((100vw-32px)*1.777/3.75+37px)]',
    '[@media(min-width:736px)]:max-h-[485px]',
  ],
});

export default VideoPlaylist;
